/**
 * ⚠️ HARDCODED DATA — temporary fixture  frontend work.
 *
 * `mockWorkspaceUsers` — the owner dropdown options. The frontend has
 * `workspaceUsersQuery(workspaceId)` ready to use, but the workspace id is
 * not currently threaded into the brief detail surface. Wiring it is part
 * of the BE story (a hydrated owner DTO will also fix this
 * naturally). Until then, a 4-name fixture.
 *
 * What is NOT mocked (real data, no fixture needed):
 *   - `brief.createdBy` (UUID) is hydrated client-side via `useUserDisplay`
 *     against Platform API `GET /users/:userId`.
 *   - `brief.title`, `brief.createdAt`, `brief.updatedAt` come from the real
 *     BriefResponseDto. The "Last modified at" line reads `brief.updatedAt`
 *     directly.
 *   - The "Brief owner" temporarily DISPLAYS the same user as the creator
 *     (because the backend has no `ownerId` column yet). This is done at
 *     the call site, not via a fixture.
 *
 * The fixture below carries a TODO marker so a global search
 * picks it up when the BE work lands.
 */
import type { UserSummary } from './types';

/** Mock workspace members for the owner dropdown. TODO: replace with workspaceUsersQuery. */
/* eslint-disable i18next/no-literal-string -- fixture data standing in for the workspace-users query */
export const mockWorkspaceUsers: UserSummary[] = [
  { id: 'mock-user-gary', name: 'Gary Neuman', avatarUrl: null },
  { id: 'mock-user-george', name: 'George Constanza', avatarUrl: null },
  { id: 'mock-user-rodrigo', name: 'Rodrigo Daud', avatarUrl: null },
  { id: 'mock-user-elaine', name: 'Elaine Benes', avatarUrl: null },
];
/* eslint-enable i18next/no-literal-string */
